/**
 * Always-visible scroll indicator for cart + size-upgrade item lists.
 *
 * Native scrollbars auto-hide on iOS/overlay-scrollbar systems, so shoppers
 * don't realise the list scrolls. This draws a passive indicator bar that is
 * visible from the moment the popup opens. It never intercepts input
 * (pointer-events: none) — scrolling still happens natively on the list.
 */
(function () {
  'use strict';

  var LIST_SELECTORS = ['.popup-cart__items', '.popup-size-upgrade__items'];

  function getLists() {
    var lists = [];
    LIST_SELECTORS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        lists.push(el);
      });
    });
    return lists;
  }

  function ensureList(list) {
    if (!list) return;

    // No overflow — no indicator needed
    if (list.scrollHeight <= list.clientHeight + 2) {
      if (list._scrollTrack) {
        list._scrollTrack.remove();
        list._scrollTrack = null;
      }
      return;
    }

    var track = list._scrollTrack;
    if (!track || !track.isConnected) {
      track = document.createElement('div');
      track.className = 'cart-items-scrollbar';
      track.setAttribute('aria-hidden', 'true');
      var thumb = document.createElement('div');
      thumb.className = 'cart-items-scrollbar__thumb';
      track.appendChild(thumb);

      var parent = list.parentElement;
      if (!parent) return;
      if (getComputedStyle(parent).position === 'static') {
        parent.style.position = 'relative';
      }
      parent.appendChild(track);
      list._scrollTrack = track;
      list.addEventListener('scroll', function () {
        updateList(list);
      }, { passive: true });
    }
    updateList(list);
  }

  function updateList(list) {
    if (!list || !list._scrollTrack || !list._scrollTrack.isConnected) return;

    var track = list._scrollTrack;
    var parent = list.parentElement;
    if (!parent) return;
    var parentRect = parent.getBoundingClientRect();
    var rect = list.getBoundingClientRect();

    track.style.top = rect.top - parentRect.top + 'px';
    track.style.height = rect.height + 'px';

    var thumb = track.firstElementChild;
    var ratio = list.clientHeight / list.scrollHeight;
    var thumbHeight = Math.max(rect.height * ratio, 24);
    var maxOffset = rect.height - thumbHeight;
    var scrollable = list.scrollHeight - list.clientHeight;
    var progress = scrollable > 0 ? list.scrollTop / scrollable : 0;

    thumb.style.height = thumbHeight + 'px';
    thumb.style.transform = 'translateY(' + maxOffset * progress + 'px)';
  }

  function ensureAll() {
    getLists().forEach(ensureList);
  }

  function updateAll() {
    getLists().forEach(updateList);
  }

  function init() {
    // Cart / upgrade content is replaced via AJAX — watch the DOM so the
    // indicator is (re)attached to the fresh list
    var observer = new MutationObserver(function () {
      ensureAll();
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'hidden']
    });

    window.addEventListener('resize', updateAll);
    document.addEventListener('size-upgrade:opened', ensureAll);
    ensureAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
